import { logger as LOG } from '@garnish/logger';

const name = 'Reorder';

export const reorderLogger = LOG.extend(name);
